import GiftOrderApi from '@apis/gift/GiftOrderApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const giftOrderQueries = createQueryKeys('giftOrder', {
  detail: (giftOrderNo: string) => ({
    queryKey: [giftOrderNo],
    queryFn: () => GiftOrderApi.getGiftOrder(giftOrderNo),
  }),
});

export default giftOrderQueries;
